import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';

import { ModalData } from 'digital-core';
import { CustomFormControl } from 'digital-core';

@Component({
  selector: 'gsp-gsp-input-modal',
  templateUrl: './gsp-input-modal.component.html',
  styleUrls: ['./gsp-input-modal.component.css']
})
export class GspInputModalComponent implements OnInit {

  public gspInputModalFg = new UntypedFormGroup({
    inputValue: new CustomFormControl()
  });
  constructor(public thisDialogRef: MatDialogRef<GspInputModalComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ModalData) { 
      thisDialogRef.disableClose = true;
    }

  ngOnInit() {
  }

  onClose(value: string) {
    this.thisDialogRef.close(this.gspInputModalFg);
  }
}
